module.exports = __webpack_public_path__ + "static/media/ad-frequency-control-icon.084043fb.svg";